// Shared Mobile Legends rank logic. Dipakai postbit (model user) & homefeed
// (raw API attributes dari /users list) biar mapping tier konsisten.
export const ML_TIERS = ['Warrior', 'Elite', 'Master', 'Grandmaster', 'Epic', 'Legend', 'Mythic', 'Mythical Honor', 'Mythical Glory', 'Mythical Immortal'];

export function slugOfTier(t) {
  return String(t).toLowerCase().replace(/ /g, '-');
}

export function tierIndexFromBadge(names) {
  if (names.includes('god')) return 8; // Mythical Glory
  if (names.includes('expert')) return 5; // Legend
  if (names.includes('intermediate')) return 4; // Epic
  if (names.includes('newbie')) return 0; // Warrior
  return null;
}

export function tierIndexFromPosts(posts) {
  if (posts >= 1000) return 9;
  if (posts >= 500) return 8;
  if (posts >= 250) return 7;
  if (posts >= 100) return 6;
  if (posts >= 50) return 5;
  if (posts >= 25) return 4;
  if (posts >= 10) return 3;
  if (posts >= 5) return 2;
  if (posts >= 1) return 1;
  return 0;
}

function namesFromBadges(badges) {
  const out = [];
  if (!badges) return out;
  const arr = Array.isArray(badges) ? badges : badges.data || badges.list || [];
  arr.forEach((b) => {
    const attrs = b && b.attributes ? b.attributes : b;
    const name = attrs && (attrs.name || attrs.title);
    if (name) out.push(String(name).toLowerCase());
  });
  return out;
}

function idsFromGroups(groups) {
  if (!groups) return [];
  const arr = Array.isArray(groups) ? groups : groups.data || groups.list || [];
  return arr.map((g) => String(g && g.id != null ? g.id : g)).filter(Boolean);
}

// attrs = attributes mentah (user.attributes) + relasi opsional { badges, groups }.
// Catatan: /api/users selalu bawa `primaryBadgeName` (dan `visibleBadges`) — itu
// sumber rank paling akurat. include=badges selalu 400, jadi jangan andalkan relasi.
export function rankOfAttrs(attrs, extra) {
  attrs = attrs || {};
  extra = extra || {};
  const names = namesFromBadges(extra.badges || attrs.badges).slice();
  // badge utama dari attribute (selalu ada di /users) — prioritas tertinggi
  if (attrs.primaryBadgeName) names.push(String(attrs.primaryBadgeName).toLowerCase());
  // visibleBadges bisa berupa string/array — tambahkan kalau ada
  if (Array.isArray(attrs.visibleBadges)) {
    attrs.visibleBadges.forEach((b) => {
      const n = b && (b.name || (b.attributes && b.attributes.name) || b);
      if (n) names.push(String(n).toLowerCase());
    });
  }

  const gids = idsFromGroups(extra.groups || attrs.groups);
  const isAdmin = gids.includes('1');
  const isMod = gids.includes('4');
  const staff = isAdmin ? 'Owner' : isMod ? 'Staff' : null;

  // prioritas: badge earned > jumlah post. Tanpa override staff (biar adil —
  // staff tanpa badge tetap dihitung dari post, bukan ditembak ke puncak).
  let idx = tierIndexFromBadge(names);
  if (idx === null) {
    const posts = attrs.commentCount || attrs.commentsCount || 0;
    idx = tierIndexFromPosts(posts);
  }

  const tier = ML_TIERS[idx];
  return {
    label: tier.toUpperCase(),
    title: tier,
    cls: 'is-' + slugOfTier(tier),
    staff,
    icon: slugOfTier(tier),
  };
}
